export enum AdminView {
  OVERVIEW = 'overview',
  USERS_ACCESS = 'users_access',
  WORKSPACES = 'workspaces',
  ORGANIZATIONS = 'organizations',
  AGENTS_WORKFLOWS = 'agents_workflows',
  MODELS_TOOLS = 'models_tools',
  DATA_INTEGRATIONS = 'data_integrations',
  MONITORING_AUDIT = 'monitoring_audit',
  SETTINGS = 'settings',
  NOTIFICATIONS = 'notifications',
}

export interface Organization {
  id: string;
  name: string;
  invite_code: string;
  plan: string;
  max_workspaces: number;
  max_users: number;
  user_count: number;
  workspace_count: number;
  created_at: string;
}

export interface OrgMember {
  user_id: string;
  email: string;
  username: string;
  role_in_org: string;
}

export interface User {
  id: string;
  name: string;
  email: string;
  company_name?: string;
  role: 'Super Admin' | 'Org Admin' | 'Workspace Admin' | 'Builder' | 'Viewer';
  status: 'Active' | 'Inactive' | 'Pending';
  lastLogin: string;
  workspaces: string[];
}


export interface WorkspaceMember {
  userId: string;
  role: 'Viewer' | 'Admin' | 'Builder';
  workspaceId: string;
  joinedAt: string;
}

export interface Workspace {
  id: string;
  name: string;
  description: string;
  owner: string;
  status: 'Active' | 'Archived';
  members: WorkspaceMember[];
  organization_name?: string;
  // keeping compatibility fields optional for now if needed during transition
  userIds?: string[];
  agentIds?: string[];
  userCount?: number; // Optional, can be derived
  agentCount?: number; // Optional
  created_at?: string; // Added for footer
}

export interface Agent {
  id: string;
  name: string;
  type: 'Chat' | 'Tool' | 'Orchestrator';
  workspace: string;
  status: 'Published' | 'Draft' | 'Deprecated';
  lastUpdated: string;
  owner: string;
}

export interface LogEntry {
  id: string;
  timestamp: string;
  agent: string;
  user: string;
  status: 'success' | 'error' | 'warning';
  latency: number;
  tokens: number;
}
